export default __webpack_public_path__ + "static/media/electricfence1.c94d7b2e.jpg";